// Contact Form Handler
const ContactForm = (function() {
    'use strict';

    function init() {
        const form = document.getElementById('contactForm');
        if (!form) return;

        // Inicjalizacja istniejących event listeners dla pól formularza
        initFormFields();

        // Nadpisanie domyślnego submita
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            handleSubmit(this);
        });

        // Inicjalizacja custom select jeśli istnieje
        if (typeof CustomSelect !== 'undefined') {
            CustomSelect.init();
        }

        // Auto-odświeżanie captchy co 5 minut
        setInterval(refreshCaptcha, 300000);
    }

    function initFormFields() {
        const inputs = document.querySelectorAll('input, textarea, select');

        inputs.forEach(input => {
            if (input.value) {
                input.parentElement.classList.add('focused');
            }

            input.addEventListener('focus', function() {
                this.parentElement.classList.add('focused');
            });

            input.addEventListener('blur', function() {
                if (!this.value) {
                    this.parentElement.classList.remove('focused');
                }
            });

            if (input.tagName === 'SELECT') {
                input.addEventListener('change', function() {
                    if (this.value) {
                        this.parentElement.classList.add('focused');
                    } else {
                        this.parentElement.classList.remove('focused');
                    }
                });
            }
        });
    }

    function handleSubmit(form) {
        // Walidacja przed wysłaniem
        if (!validateForm(form)) {
            return;
        }

        const submitBtn = form.querySelector('button[type="submit"]');
        const originalText = submitBtn.textContent;

        // Pokaż stan ładowania
        submitBtn.disabled = true;
        submitBtn.textContent = 'Wysyłanie...';

        // Przygotuj dane formularza
        const formData = new FormData(form);
        const data = {
            name: formData.get('name'),
            email: formData.get('email'),
            category: formData.get('category'),
            subject: formData.get('subject'),
            message: formData.get('message'),
            captchaInput: formData.get('captchaInput'),
            sendContactMessage: '1'
        };

        // Wyślij przez AJAX
        fetch('/ajax', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams(data)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(result => {
                if (result.success) {
                    showFormMessage(result.message || 'Wiadomość została wysłana pomyślnie!', 'success');
                    resetForm(form);
                } else {
                    showFormMessage(result.message || 'Wystąpił błąd podczas wysyłania wiadomości.', 'error');

                    // Jeśli błąd dotyczy captchy, odśwież ją
                    if (result.message && result.message.toLowerCase().includes('captcha')) {
                        refreshCaptcha();
                    }
                }
            })
            .catch(error => {
                console.error('Contact form error:', error);
                showFormMessage('Wystąpił błąd podczas wysyłania wiadomości. Spróbuj ponownie.', 'error');
            })
            .finally(() => {
                // Przywróć przycisk
                submitBtn.disabled = false;
                submitBtn.textContent = originalText;
            });
    }

    function validateForm(form) {
        let isValid = true;
        let firstErrorField = null;
        const requiredFields = form.querySelectorAll('[required]');

        // Usuń istniejące błędy
        document.querySelectorAll('.has-error').forEach(el => {
            el.classList.remove('has-error');
        });

        requiredFields.forEach(field => {
            let fieldValue = field.value.trim();
            let hasError = false;

            if (!fieldValue) {
                hasError = true;
            }

            if (field.type === 'checkbox' && !field.checked) {
                hasError = true;
            }

            if (field.type === 'email' && fieldValue) {
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(fieldValue)) {
                    hasError = true;
                }
            }

            if (field.name === 'name' && fieldValue && fieldValue.length < 3) {
                hasError = true;
            }

            if (field.name === 'subject' && fieldValue && fieldValue.length < 5) {
                hasError = true;
            }

            if (field.name === 'message' && fieldValue && fieldValue.length < 10) {
                hasError = true;
            }

            if (hasError) {
                field.parentElement.classList.add('has-error');
                isValid = false;
                if (!firstErrorField) {
                    firstErrorField = field;
                }
            }
        });

        if (!isValid && firstErrorField) {
            firstErrorField.focus();
            showFormMessage('Proszę wypełnić wszystkie wymagane pola poprawnie.', 'error');
        }

        return isValid;
    }

    function resetForm(form) {
        form.reset();

        // Reset custom select jeśli istnieje
        if (typeof CustomSelect !== 'undefined') {
            const customSelect = form.querySelector('.custom-select');
            if (customSelect) {
                CustomSelect.reset(customSelect);
            }
        }

        // Reset focus na polach
        const inputs = form.querySelectorAll('input, textarea, select');
        inputs.forEach(input => {
            input.parentElement.classList.remove('focused');
        });

        // Odśwież captcha
        refreshCaptcha();

        // Wyczyść pole captcha
        const captchaInput = form.querySelector('#captchaInput');
        if (captchaInput) {
            captchaInput.value = '';
        }
    }

    function showFormMessage(message, type) {
        const existingMessages = document.querySelectorAll('.form-message.dynamic');
        existingMessages.forEach(msg => msg.remove());

        const messageDiv = document.createElement('div');
        messageDiv.className = `form-message ${type} dynamic`;
        messageDiv.textContent = message;

        const form = document.getElementById('contactForm');
        if (form) {
            const formTitle = form.querySelector('.form-title');
            if (formTitle) {
                formTitle.insertAdjacentElement('afterend', messageDiv);
            } else {
                // Jeśli nie ma tytułu, dodaj na początku formularza
                form.insertBefore(messageDiv, form.firstChild);
            }

            // Auto-ukrywanie po 5 sekundach dla sukcesu, dłużej dla błędów
            const timeout = type === 'success' ? 5000 : 8000;

            setTimeout(() => {
                messageDiv.style.opacity = '0';
                setTimeout(() => {
                    if (messageDiv.parentNode) {
                        messageDiv.remove();
                    }
                }, 300);
            }, timeout);
        }
    }

    return {
        init: init
    };
})();

// Funkcja odświeżania captchy
function refreshCaptcha() {
    var captchaImage = document.querySelector('.captcha-image');
    if (captchaImage) {
        captchaImage.src = '/captcha.php?t=' + new Date().getTime();
    }
}

// Inicjalizacja po załadowaniu DOM
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
        ContactForm.init();
    });
} else {
    ContactForm.init();
}